export default __webpack_public_path__ + "static/lg-59d156f642e79a5e28304e0c453f1e2f.png";